const FINISH_PARAM = 'filter.v.option.finish';
const FINISH_NAMES = {
  SW: 'Shaker White', GR: 'Shaker Gray', SE: 'Shaker Espresso', NB: 'Navy Blue', SC: 'Shaker Charcoal',
  AW: 'Aspen White', AC: 'Aspen Charcoal Gray', CW: 'Charleston White', CS: 'Charleston Saddle',
  AG: 'Aston Green', IB: 'Iron Black', TC: 'Treasure Chest', RW: 'Rustic Wood', LG: 'Lunar Gray',
  DDW: 'Double Dove White', SB: 'Sage Breeze', SIB: 'Slim Iron Black', SAO: 'Slim Amber Oak',
  SAG: 'Slim Aston Green', SWO: 'Slim White Oak', SDW: 'Slim Dove White', HG: 'High Gloss Gray',
  HW: 'High Gloss White', CG: 'Crystal Glass', MB: 'Matte Black', MG: 'Midnight Glass',
  OB: 'Oak Blonde', OS: 'Oak Shade', MI: 'Matte Ivory',
};

const normalize = (value) => String(value || '').trim().toUpperCase();

const activeFinish = () => {
  const context = document.querySelector('[data-cdw-active-finish]')?.dataset.cdwActiveFinish;
  return normalize(context || new URLSearchParams(window.location.search).get(FINISH_PARAM));
};

const parseVariants = (card) => {
  try {
    const node = card.querySelector('[data-cdw-variant-data]');
    const value = JSON.parse(node?.textContent || '[]');
    return Array.isArray(value) ? value : [];
  } catch (_error) {
    return [];
  }
};

const presentationImage = (variant) => {
  const variantArea = Number(variant.imageWidth || 0) * Number(variant.imageHeight || 0);
  const qualityArea = Number(variant.qualityImageWidth || 0) * Number(variant.qualityImageHeight || 0);
  const useQualityFallback = Boolean(variant.qualityImage && variantArea < 150000 && qualityArea > variantArea);
  return {
    url: useQualityFallback ? variant.qualityImage : variant.image,
    isFallback: useQualityFallback,
  };
};

const updateImage = (card, variant) => {
  const presentation = presentationImage(variant);
  if (!presentation.url) return;
  const gallery = card.querySelector('.card-gallery');
  const image = gallery?.querySelector('img');
  if (!(image instanceof HTMLImageElement)) return;
  gallery?.removeAttribute('on:pointerenter');
  gallery?.removeAttribute('on:pointerleave');
  image.src = presentation.url;
  image.srcset = presentation.url;
  const productName = card.querySelector('h3')?.textContent?.trim();
  image.alt = presentation.isFallback
    ? `${productName || variant.sku} — high-resolution cabinet drawing`
    : [variant.sku, productName].filter(Boolean).join(' — ') || `${variant.sku} product image`;
  image.dataset.cdwFinishImage = variant.finish;
  card.dataset.featuredMediaUrl = presentation.url;
};

const updateLinks = (card, variant) => {
  if (!variant.url) return;
  card.querySelectorAll('a[href]').forEach((link) => {
    if (!(link instanceof HTMLAnchorElement)) return;
    if (link.closest('[data-cdw-project-root]')) return;
    link.href = variant.url;
  });
};

const updatePrice = (card, variant) => {
  const prices = card.querySelectorAll('product-price .price');
  const price = prices[prices.length - 1];
  if (price) price.textContent = variant.priceFormatted || '';
  const compare = card.querySelector('product-price .compare-at-price');
  if (compare) {
    compare.textContent = Number(variant.compareAtPrice) > Number(variant.price) ? variant.compareAtPriceFormatted : '';
    compare.hidden = !compare.textContent;
  }
};

const updateProjectButton = (card, variant) => {
  const button = card.querySelector('[data-cdw-project-save]');
  if (!(button instanceof HTMLElement)) return;
  button.dataset.variantId = variant.id || '';
  button.dataset.productSku = variant.sku || '';
  button.dataset.productFinish = FINISH_NAMES[normalize(variant.finish)] || variant.finish || '';
  button.dataset.productPrice = variant.priceFormatted || '';
  button.dataset.productUnitPrice = String(variant.price || 0);
  button.dataset.productUrl = variant.url || '';
  button.dataset.productImage = presentationImage(variant).url || '';
};

const updateCard = (card, finish) => {
  const variants = parseVariants(card);
  const variant = variants.find((item) => normalize(item.finish) === finish || normalize(item.sku).startsWith(`${finish}-`));
  if (!variant) return;

  card.dataset.cdwActiveFinish = finish;
  card.dataset.cdwActiveVariant = variant.id || '';
  updateImage(card, variant);
  updateLinks(card, variant);
  updatePrice(card, variant);
  updateProjectButton(card, variant);

  const sku = card.querySelector('[data-cdw-card-sku]');
  if (sku) sku.textContent = variant.sku || '';
  const finishLabel = card.querySelector('[data-cdw-card-finish]');
  if (finishLabel) finishLabel.textContent = FINISH_NAMES[finish] || variant.finish || finish;
  const availability = card.querySelector('.cdw-card-copy__availability');
  if (availability) {
    availability.dataset.available = String(Boolean(variant.available));
    availability.textContent = variant.available ? 'Available to order' : 'Confirm availability';
  }
};

const updateCards = () => {
  const finish = activeFinish();
  if (!finish) return;
  document.querySelectorAll('[data-cdw-catalog-card]').forEach((card) => updateCard(card, finish));
  document.dispatchEvent(new CustomEvent('cdw:catalog:updated'));
};

const setQueryValue = (name, value) => {
  const url = new URL(window.location.href);
  url.searchParams.delete('page');
  if (value) url.searchParams.set(name, value);
  else url.searchParams.delete(name);
  url.hash = 'ResultsList';
  window.location.assign(url.toString());
};

const syncConfigurator = () => {
  const url = new URL(window.location.href);
  document.querySelectorAll('[data-cdw-query-param]').forEach((control) => {
    const parameter = control.dataset.cdwQueryParam || '';
    const current = url.searchParams.get(parameter) || '';
    if (control instanceof HTMLSelectElement) control.value = current;
    if (control instanceof HTMLButtonElement && control.hasAttribute('data-cdw-query-value')) {
      control.setAttribute('aria-pressed', String(current === (control.dataset.cdwQueryValue || '')));
    }
  });
  document.querySelectorAll('[data-cdw-type-value]').forEach((button) => {
    const active = url.searchParams.get('filter.p.m.aline.cabinet_type') === button.dataset.cdwTypeValue;
    button.setAttribute('aria-pressed', String(active));
  });
};

document.addEventListener('change', (event) => {
  const control = event.target.closest('[data-cdw-query-param]');
  if (!(control instanceof HTMLSelectElement)) return;
  setQueryValue(control.dataset.cdwQueryParam || '', control.value);
});

document.addEventListener('click', (event) => {
  const dimensionButton = event.target.closest('[data-cdw-query-value]');
  if (dimensionButton instanceof HTMLButtonElement) {
    const parameter = dimensionButton.dataset.cdwQueryParam || '';
    const value = dimensionButton.dataset.cdwQueryValue || '';
    const current = new URL(window.location.href).searchParams.get(parameter) || '';
    setQueryValue(parameter, current === value && value ? '' : value);
    return;
  }

  const button = event.target.closest('[data-cdw-type-value]');
  if (!(button instanceof HTMLButtonElement)) return;
  const current = new URL(window.location.href).searchParams.get('filter.p.m.aline.cabinet_type');
  setQueryValue('filter.p.m.aline.cabinet_type', current === button.dataset.cdwTypeValue ? '' : button.dataset.cdwTypeValue || '');
});

document.addEventListener('shopify:collection:update', (event) => {
  event.detail?.promise?.then(() => window.requestAnimationFrame(() => {
    updateCards();
    syncConfigurator();
  }));
});

document.addEventListener('DOMContentLoaded', () => {
  updateCards();
  syncConfigurator();
});
